module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wsplus-body",
    class: _vm.leftSideOpen ? 'left-side-collapsed' : ''
  }, [_c('ws-header'), _vm._v(" "), _c('ws-content'), _vm._v(" "), _c('ws-tip')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5cdb833a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/main.vue
// module id = 1121
// module chunks = 99